import { Injectable } from '@angular/core';

import { EnumModel } from '../../models/models';

@Injectable()
export class EnumProvider {
  private enums: EnumModel[] = [];

  constructor() {
  }

  Get(type, id) {
    return this.enums.find(x => x.Type === type && x._id === id);
  }

  List(type = null) {
    if (type) return this.enums.filter(x => x.Type === type);
    else return this.enums;
  }

}



// WEBPACK FOOTER //
// ./src/providers/enum/enum.ts